import React from 'react';
import { t } from 'ttag';
import style from './basicModelBox.scss';
import Price from '../../util/Price';

function BasicModelBox(props) {
    let containerStyle = style.container;
    const { model, selectedModel, onSelectBox } = props;
    const onChange = () => onSelectBox(model);

    if (model.id === selectedModel) {
        containerStyle = style.container__active;
    }

    return (
        <label htmlFor={model.id}>
            <input className={style.radio} type="radio" value={model.id} id={model.id} checked={model.id === selectedModel} onChange={() => onChange()} />
            <div className={containerStyle}>
                <img className={style.basicmodelimage} src={`/${model.groundPlan.href}`} alt={model.name} />
                <div className={style.details}>
                    <h2>{model.name}</h2>
                    <h3>{t`ab`} <Price value={model.lowestPrice} /></h3>
                </div>
            </div>
        </label>
    );
}
export default BasicModelBox;
